<template>
        <div class="templateMedical">
            <h4 class=" text-center text-secondary pt-5"> ဆေးဝါးအိမ်အရောက်ပို့အကူအညီ </h4>
             <div class="row m-5">
                        <div class=" col-md-5 mx-auto d-block card m-3 p-4 card-glass " v-for="medical in medicals" :key="medical.id">
                                <div class="card-body">
                                    <h5 class="card-title text-danger"> {{ medical.name }}</h5>
                                    <div class="row mt-3">
                                        <div class="col-md-6 ">
                                                <div class="row">
                                                            <div class="col">
                                                                    <span class="link-dark">ဖုန်း - </span>
                                                            </div>
                                                            <div class="col">
                                                                        <div class="mb-1">
                                                                            <a  :href="'tel:'+medical.ph" class=" text-decoration-none">  {{medical.ph}}</a> 
                                                                        </div>

                                                                        <div class="mb-1">
                                                                            <a  :href="'tel:'+medical.ph1" class=" text-decoration-none">  {{medical.ph1}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+medical.ph2" class=" text-decoration-none">   {{medical.ph2}}</a> 
                                                                        </div>

                                                                            <div class="mb-1">
                                                                            <a  :href="'tel:'+medical.ph3" class=" text-decoration-none">  {{medical.ph3}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+medical.ph4" class=" text-decoration-none">  {{medical.ph4}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+medical.ph5"  class=" text-decoration-none"> {{medical.ph5}}</a> 
                                                                        </div>
                                                                           <div>
                                                                            <a  :href="'tel:'+medical.ph6" class=" text-decoration-none">  {{medical.ph7}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+medical.ph7"  class=" text-decoration-none"> {{medical.ph7}}</a> 
                                                                        </div>
                                                            </div>

                                                    </div>
                                                  
                                            </div>
                                              <small class="text-muted mt-2"> ဖုန်းနံပါတ်ကိုနှိပ်ပြီးခေါ်ဆိုနိုင်ပါသည် </small>

                                               <div class="mt-3 ">
                                                    <span>လိပ်စာ - </span><small class="bg-white p-2"> {{ medical.note}} </small>
                                            </div>
                                    </div>
                                  
                                   
                                 
                                    
                                </div>
                        </div>      

            </div>        
           
        </div>
          
</template>

<script>
export default {
    name: "Medical",

    data(){
        return {
    medicals : [
        {name:'ကိုသူရ Pharmacy', ph:'+9595161786',ph2:'+959785161786', note:'ရွှေပြည့်စုံဈေး'},
        {name:'ထူးသဇင် Pharmacy', ph:'+959795743828', note:'မင်းရဲကျော်စွာလမ်း၊ ဒဂုံမြို့နယ်'},
        {name:'မြတ်မြင့်မိုရ်', ph:'+959890492851', ph1:'+959890492852', ph2:'+959890492853' , note:'၄၀၂၊ အင်းဝလမ်း၊ ၆ ရပ်ကွက်၊ တ/ဥက္ကလာ'},
        {name:'One Parmacy', ph:'+9595151594'},
        {name:'Aung Parmacy', ph:'+9599441739142', note:'တပင်ရွှေထီးလမ်း'},
        {name:'ဇီဝဆေးဆိုင်', ph:'+959887375511', ph1:'+959887375522', note:'အမှတ်(၃) မဟာဗန္ဓုလလမ်း၊ (၂၉) ရပ်ကွက်၊မ/ဒဂုံ'},
        {name:'ဇီဝဆေးဆိုင်' , ph:'+959887375533', ph1:'+959887375544', note:'၁၈၀၊ ရေတာရှည်လမ်းဟောင်း နှင့် အနောက်ရွှေဂုံတိုင်လမ်း'},
        {name:'မုဒိတာ Pharmacy', ph:'+9599605066672', note:'အမှတ်(၁၀) ၊ ၁၄၅လမ်း၊ တာမွေ'},
        {name:'လင်းမိသားစု', ph:'+959263544405', ph1:'+959450552259', note:'E-၃၆ တတိယထပ် ရွှေပြည့်စုံဈေး'},
        {name:'Medimall', ph:'+959778612600', note:'2A KBS Condo ပြည်သာယာလမ်း၊ဘောက်ထော်'},
        {name:'ရွှေချမ်းသာဆေးဆိုင်', ph:'+9595061940', note:'အခန်း(၁)၊ တိုက် ၁၅၅ ကောက်လျင်လမ်း၊ သုဝဏ္ဏ'},
        {name:'သစ်ခွ (Orchid)', ph:'+959770619222', note:'အမှတ်(၃)၊ သီတာလမ်း၊ တာမွေ' },
        {name:'Amethyst', ph:'01299555', note:'၃၄ စပယ်လမ်း၊ ဘိုလိန်းအောင်မင်္ဂလာ တာမွေ'}


        
    ]
    }

    }

   
}
</script>

<style>
       .templateMedical {
       
          background:linear-gradient(to right top, #f7e9be, #e2e8e9);
          overflow: hidden;
       
          align-items: center;
          justify-content: center;
          
        }
</style>



ကိုသူရ Pharmacy ရွှေပြည့်စုံဈေး

ထူးသဇင် Pharmacy မင်းရဲကျော်စွာလမ်း၊ ဒဂုံမြို့နယ်

မြတ်မြင့်မိုရ်  ၄၀၂၊ အင်းဝလမ်း၊ ၆ ရပ်ကွက်၊ တ/ဥက္ကလာ

One Parmacy

Aung Parmacy တပင်ရွှေထီးလမ်း

ဇီဝဆေးဆိုင်  အမှတ်(၃) မဟာဗန္ဓုလလမ်း၊ (၂၉) ရပ်ကွက်၊
 မ/ဒဂုံ

ဇီဝဆေးဆိုင် ၁၈၀၊ ရေတာရှည်လမ်းဟောင်း နှင့် 
အနောက်ရွှေဂုံတိုင်လမ်း

မုဒိတာ Pharmacy အမှတ်(၁၀) ၊ ၁၄၅လမ်း၊ တာမွေ

လင်းမိသားစု  E-၃၆ တတိယထပ် ရွှေပြည့်စုံဈေး

Medimall   2A KBS Condo ပြည်သာယာလမ်း၊
ဘောက်ထော်

ရွှေချမ်းသာဆေးဆိုင်   အခန်း(၁)၊ တိုက် ၁၅၅ 
ကောက်လျင်လမ်း၊ သုဝဏ္ဏ

သစ်ခွ (Orchid)  အမှတ်(၃)၊ သီတာလမ်း၊ တာမွေ

Amethyst ၃၄ စပယ်လမ်း၊ ဘိုလိန်းအောင်မင်္ဂလာ 
တာမွေ